import { ScrollView, View } from 'react-native';
import { Tabs } from '../../../components/primitives/Tabs';
import { useTranslation } from '../../../contexts/TranslationContext';
import { tokens } from '../../../theme/tokens';

export type AnalyticsTabKey = 'overview' | 'funnel' | 'campaigns' | 'team';

interface AnalyticsTabsProps {
  activeTab: AnalyticsTabKey;
  onTabChange: (tab: AnalyticsTabKey) => void;
}

const TABS = [
  { key: 'overview', labelKey: 'analytics.tabs.overview' },
  { key: 'funnel', labelKey: 'analytics.tabs.funnel' },
  { key: 'campaigns', labelKey: 'analytics.tabs.campaigns' },
  { key: 'team', labelKey: 'analytics.tabs.team' },
];

// iOS / Yoga collapses horizontal ScrollView height to 0 when it sits inside a
// VStack with alignItems:'stretch'. The View wrapper with flexShrink:0 + an
// explicit min-height keeps the ScrollView's vertical box stable while the
// horizontal scroll handles narrow viewports.
const TABS_ROW_HEIGHT = 52;

export function AnalyticsTabs({ activeTab, onTabChange }: Readonly<AnalyticsTabsProps>) {
  const { t } = useTranslation();
  const tabs = TABS.map((tab) => ({ key: tab.key, label: t(tab.labelKey) }));

  return (
    <View style={{ flexShrink: 0, minHeight: TABS_ROW_HEIGHT }}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          paddingVertical: tokens.spacing.sm,
          alignItems: 'center',
        }}
      >
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={(key) => onTabChange(key as AnalyticsTabKey)}
          variant="pills"
          testID="analytics_tabs"
        />
      </ScrollView>
    </View>
  );
}
